<div #contactForm class="card contact-form column is-narrow">
	<div class="card-content">
		<h3 class="title is-4 has-text-centered red">{{ title }}</h3>
		<form>
			<div class="columns" [formGroup]="generalForm">
				<div class="column" >
					<h4 *ngIf="isEquipmentForm || isCourseForm" class="blue form-title has-text-centered">Datos de contacto</h4>
					<!-- Name -->
					<div class="field">
						<div class="control">
							<input formControlName="name" class="input" placeholder="Nombre completo/Nombre de la empresa">
						</div>
					</div>
					<!-- Email -->
					<div class="field">
						<div class="control">
							<input formControlName="email" class="input" placeholder="Correo">
						</div>
					</div>
					<!-- Phone -->
					<div class="field">
						<div class="control">
							<input formControlName="phone" class="input" placeholder="Teléfono">
						</div>
					</div>
					<!-- Message -->
					<div class="field">
						<div class="control">
							<textarea formControlName="message" class="textarea" cols="30" rows="5" placeholder="Mensaje"></textarea>
						</div>
					</div>
				</div>
					
				<!-- Equipment forms -->
				<div *ngIf="isEquipmentForm" formArrayName="equipment" class="column">
					<h4 class="blue form-title has-text-centered">{{ secondFormSubtitle }}</h4>
					<ng-container *ngFor="let equipment of equipmentForms.controls;let i = index" [formGroupName]="i">
						<div class="field is-horizontal">
							<div class="field-body">
								<!-- Brand -->
								<div class="field">
									<div class="control">
										<input formControlName="brand" class="input" placeholder="Marca" />
									</div>
								</div>
								<!-- Model -->
								<div class="field">
									<div class="control">
										<input formControlName="model" class="input" placeholder="Modelo" />
									</div>
								</div>
							</div>
						</div>
						<!-- Technical requirements -->
						<div class="field">
							<div class="control">
								<textarea formControlName="technicalRequirements" class="textarea" cols="30" rows="2" placeholder="Requerimientos técnicos"></textarea>
							</div>
						</div>
					</ng-container>
					<button (click)="addEquipment()" class="button is-small">Agregar equipo</button>
				</div>

				<!-- Courses forms -->
				<div *ngIf="isCourseForm" formArrayName="courses" class="column">
					<h4 class="blue form-title has-text-centered">{{ secondFormSubtitle }}</h4>
					<ng-container *ngFor="let course of coursesForms.controls; let i = index" [formGroupName]="i">
						<!-- Course code. -->
						<div class="field">
							<div class="control">
								<input formControlName="code" type="text" class="input" placeholder="Código de curso">
							</div>
						</div>
						<div class="field is-horizontal">
							<div class="field-body">
								<!-- People -->
								<div class="field">
									<div class="control">
										<input formControlName="people" class="input" type="number" placeholder="Personas" />
									</div>
								</div>
								<!-- City -->
								<div class="field">
									<div class="control">
										<input formControlName="city" class="input" type="text" placeholder="Ciudad" />
									</div>
								</div>
							</div>
						</div>
						<!-- Comments -->
						<div class="field">
							<div class="control">
								<textarea formControlName="comments" class="textarea" cols="30" rows="2" placeholder="Comentarios"></textarea>
							</div>
						</div>
					</ng-container>
					<button (click)="addCourse()" class="button is-small">Agregar curso</button>
				</div>
			</div>
		</form>
		<button class="button is-link" (click)="sendForm()">{{ buttonText }}</button>
	</div>
</div>
